/** Public Shopify product suggestions. The native GET search form always remains available. */
(function (host, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) {
    function boot() { api.boot(host); }
    if (host.document.readyState === 'loading') host.document.addEventListener('DOMContentLoaded', boot, { once:true });
    else boot();
    host.document.addEventListener('shopify:section:load', boot);
    host.document.addEventListener('shopify:section:unload', function (event) { api.unmount(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var instances = new WeakMap();
  var QUERY = 'query ProductSuggestions($q: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) { search(first: 6, query: $q, types: [PRODUCT], unavailableProducts: LAST) { nodes { ... on Product { id title handle availableForSale featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } } } } }';
  function query(value) {
    if (typeof value !== 'string') return '';
    var q = value.trim();
    return Array.from(q).length >= 3 && q.length <= 300 && !/[\u0000-\u001f\u007f]/.test(q) ? q : '';
  }
  /* Feinschliff 31.10.2026: Buchstabensalat erkennen (gleiche Regel wie snippets/pg-search-nonsense.liquid).
     Shopify ergänzt Suchen semantisch und liefert sonst auch für «zzqxwvkkpq» Zufallstreffer. */
  function nonsense(value) {
    if (typeof value !== 'string' || value.indexOf(':') !== -1) return false;
    var words = value.toLowerCase().replace(/sch/g, '§').split(/\s+/), checked = 0;
    for (var i = 0; i < words.length; i++) {
      if (/[0-9]/.test(words[i])) return false;
      var w = words[i].replace(/[^a-zäöüéèàçß§]/g, '');
      if (w.length >= 2 && w.length < 5) return false;
      if (w.length < 5) continue;
      checked++;
      if (/[aeiouyäöüéèà]/.test(w) && !/(.)\1{3}/.test(w) && !/[^aeiouyäöüéèà]{6}/.test(w)) return false;
    }
    return checked > 0;
  }
  function rootPath(value) {
    return typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[a-zA-Z0-9]{2,8})?\/?)?$/.test(value) ? value.replace(/\/$/, '') + '/' : null;
  }
  function searchPath(value) {
    return typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[a-zA-Z0-9]{2,8})?\/)?search$/.test(value) ? value : null;
  }
  function endpoint(value) { return value === '/api/2026-07/graphql.json' ? value : null; }
  function countryCode(value) { return typeof value === 'string' && /^[a-z]{2}$/i.test(value) ? value.toUpperCase() : null; }
  function languageCode(value) {
    if (typeof value !== 'string' || !/^[a-z]{2}(?:-[a-z]{2})?$/i.test(value)) return null;
    var parts = value.toUpperCase().split('-');
    if (parts[0] === 'ZH') return parts[1] === 'CN' || parts[1] === 'TW' ? parts.join('_') : null;
    return parts[0];
  }
  function handle(value) { return typeof value === 'string' && value.length <= 255 && /^[\p{L}\p{M}\p{N}_™®-]+$/u.test(value) ? value : null; }
  function productUrl(root, value) { var prefix = rootPath(root); var name = handle(value); return prefix && name ? prefix + 'products/' + encodeURIComponent(name) : null; }
  function allResultsUrl(path, value) { var base = searchPath(path); var q = query(value); return base && q ? base + '?q=' + encodeURIComponent(q) : null; }
  function imageUrl(value) {
    if (typeof value !== 'string' || value.length > 2048 || /[\s\\\u0000-\u001f\u007f]/.test(value)) return null;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password && !url.port &&
        ['cdn.shopify.com', 'pixelgipfel.ch', 'www.pixelgipfel.ch'].indexOf(url.hostname) >= 0 ? url.href : null;
    } catch (_) { return null; }
  }
  function money(value) {
    if (!value || typeof value.currencyCode !== 'string' || !/^[A-Z]{3}$/.test(value.currencyCode) ||
      !(typeof value.amount === 'number' || (typeof value.amount === 'string' && /^\d+(?:\.\d+)?$/.test(value.amount)))) throw new Error('invalid_response');
    var amount = Number(value.amount);
    if (!Number.isFinite(amount) || amount < 0) throw new Error('invalid_response');
    return { amount:amount, currencyCode:value.currencyCode };
  }
  function normalize(body, root) {
    if (!rootPath(root) || !body || (body.errors && (!Array.isArray(body.errors) || body.errors.length)) || !body.data || !body.data.search || !Array.isArray(body.data.search.nodes) || body.data.search.nodes.length > 6) throw new Error('invalid_response');
    var ids = new Set();
    return body.data.search.nodes.map(function (node) {
      if (!node || typeof node.id !== 'string' || !/^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(node.id) || ids.has(node.id) ||
        typeof node.title !== 'string' || !node.title.trim() || node.title.length > 500 || /[\u0000-\u001f\u007f]/.test(node.title) ||
        !handle(node.handle) || typeof node.availableForSale !== 'boolean') throw new Error('invalid_response');
      ids.add(node.id);
      var price = money(node.priceRange && node.priceRange.minVariantPrice);
      var img = node.featuredImage;
      return { id:node.id, handle:node.handle, title:node.title, url:productUrl(root, node.handle), available:node.availableForSale,
        price:price, image:img ? imageUrl(img.url) : null, alt:img && typeof img.altText === 'string' && img.altText.length <= 500 ? img.altText : null };
    });
  }
  function formatMoney(price, locale) {
    try { return new Intl.NumberFormat(locale || 'de-CH', { style:'currency', currency:price.currencyCode }).format(price.amount); }
    catch (_) { return new Intl.NumberFormat('de-CH', { style:'currency', currency:price.currencyCode }).format(price.amount); }
  }
  function mount(root, win) {
    if (!root || root.hasAttribute('data-enhanced') || instances.has(root)) return null;
    var doc = root.ownerDocument || win.document;
    var form = root.querySelector('[data-pg-smart-search-form]');
    var input = form && form.querySelector('input[name="q"]');
    var panel = root.querySelector('[data-pg-smart-search-panel]');
    var status = root.querySelector('[data-pg-smart-search-status]');
    var list = root.querySelector('[data-pg-smart-search-results]');
    var all = root.querySelector('[data-pg-smart-search-all]');
    var apiUrl = endpoint(root.getAttribute('data-endpoint'));
    var prefix = rootPath(root.getAttribute('data-root-url'));
    var search = searchPath(root.getAttribute('data-search-url'));
    var country = countryCode(root.getAttribute('data-country'));
    var language = languageCode(root.getAttribute('data-language'));
    var locale = root.getAttribute('data-locale') || 'de-CH';
    if (/^[a-z]{2}$/i.test(locale) && country) locale += '-' + country;
    var copy = {};
    ['loading','empty','error','results','from','unavailable','image-alt'].forEach(function (key) { copy[key] = root.getAttribute('data-' + key); });
    if (!form || !input || !panel || !status || !list || !all || !apiUrl || !prefix || !search || !country || !language ||
      typeof win.fetch !== 'function' || typeof win.AbortController !== 'function' || Object.keys(copy).some(function (key) { return !copy[key]; })) return null;
    var generation = 0, debounce = null, timeout = null, controller = null;
    var disposed = false, composing = false;
    var removers = [];
    function listen(target, event, callback) { target.addEventListener(event, callback); removers.push(function () { target.removeEventListener(event, callback); }); }
    function cancel() {
      generation++;
      if (debounce !== null) win.clearTimeout(debounce);
      if (timeout !== null) win.clearTimeout(timeout);
      debounce = null; timeout = null;
      if (controller) controller.abort(); controller = null;
      root.removeAttribute('aria-busy');
    }
    function close() { cancel(); panel.hidden = true; list.replaceChildren(); status.textContent = ''; }
    function state(key, count) {
      panel.hidden = false;
      status.textContent = copy[key].replace(/\{\{\s*count\s*\}\}/g, String(count || 0));
    }
    function element(tag, className, text) {
      var node = doc.createElement(tag); node.className = className;
      if (text !== undefined) node.textContent = text; return node;
    }
    function render(products) {
      list.replaceChildren();
      products.forEach(function (product) {
        var item = element('li', 'pg-smart-search__item');
        var link = element('a', 'pg-smart-search__link'); link.href = product.url;
        if (product.image) {
          var img = element('img', 'pg-smart-search__image'); img.src = win.PGProductImage ? win.PGProductImage(product.handle, product.image) : product.image; img.alt = product.alt || copy['image-alt']; img.width = 64; img.height = 64; img.loading = 'lazy';
          img.addEventListener('error', function () { img.remove(); }, { once:true });
          link.appendChild(img);
        }
        var body = element('span', 'pg-smart-search__body');
        var displayTitle = win.PGProductTitle ? win.PGProductTitle(product.handle, product.title) : product.title;
        body.appendChild(element('span', 'pg-smart-search__title', displayTitle));
        body.appendChild(element('span', 'pg-smart-search__price', copy.from + ' ' + formatMoney(product.price, locale)));
        if (product.available === false) body.appendChild(element('span', 'pg-smart-search__availability', copy.unavailable));
        link.appendChild(body); item.appendChild(link); list.appendChild(item);
      });
      state(products.length ? 'results' : 'empty', products.length);
    }
    async function request(q, version) {
      if (disposed || version !== generation) return;
      debounce = null;
      var pending = new win.AbortController(); controller = pending;
      root.setAttribute('aria-busy', 'true');
      timeout = win.setTimeout(function () {
        if (disposed || version !== generation) return;
        cancel(); state('error');
      }, 8000);
      try {
        var response = await win.fetch(apiUrl, { method:'POST', credentials:'omit', mode:'same-origin', cache:'no-store', redirect:'error', referrerPolicy:'no-referrer', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({ query:QUERY, variables:{q:q,country:country,language:language} }), signal:pending.signal });
        if (disposed || version !== generation) return;
        if (!response.ok) throw new Error('search_unavailable');
        var data = await response.json();
        if (disposed || version !== generation) return;
        render(normalize(data, prefix));
      } catch (_) {
        if (!disposed && version === generation) { list.replaceChildren(); state('error'); }
      } finally {
        if (version === generation) {
          if (timeout !== null) win.clearTimeout(timeout);
          timeout = null; controller = null; root.removeAttribute('aria-busy');
        }
      }
    }
    function searchInput() {
      if (disposed) return;
      close();
      var q = query(input.value);
      if (composing || doc.hidden || !q) return;
      all.href = allResultsUrl(search, q);
      if (nonsense(q)) { render([]); return; }
      state('loading');
      var version = generation;
      debounce = win.setTimeout(function () { request(q, version); }, 600);
    }
    listen(input, 'input', searchInput);
    listen(input, 'compositionstart', function () { composing = true; close(); });
    listen(input, 'compositionend', function () { composing = false; searchInput(); });
    listen(root, 'keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); input.focus(); }
      else if (event.key === 'ArrowDown' && event.target === input && !panel.hidden) {
        var first = list.querySelector('a');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    listen(form, 'submit', close);
    listen(doc, 'click', function (event) { if (!root.contains(event.target)) close(); });
    listen(doc, 'focusin', function (event) { if (!root.contains(event.target)) close(); });
    listen(doc, 'visibilitychange', function () { if (doc.hidden) close(); });
    listen(win, 'pagehide', close);
    root.setAttribute('data-enhanced', 'true');
    var instance = { close:close, dispose:function () { disposed = true; close(); removers.forEach(function (remove) { remove(); }); root.removeAttribute('data-enhanced'); instances.delete(root); } };
    instances.set(root, instance); return instance;
  }
  function roots(scope) {
    var found = [];
    if (scope.matches && scope.matches('[data-pg-smart-search]')) found.push(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-pg-smart-search]').forEach(function (root) { found.push(root); });
    return found;
  }
  function boot(win) { roots(win.document).forEach(function (root) { mount(root, win); }); }
  function unmount(scope) { roots(scope).forEach(function (root) { var instance = instances.get(root); if (instance) instance.dispose(); }); }
  return { QUERY:QUERY, query:query, nonsense:nonsense, rootPath:rootPath, searchPath:searchPath, endpoint:endpoint, countryCode:countryCode, languageCode:languageCode, handle:handle, productUrl:productUrl, allResultsUrl:allResultsUrl, imageUrl:imageUrl, normalize:normalize, formatMoney:formatMoney, mount:mount, boot:boot, unmount:unmount };
});
